import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25513f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "buyTicketSticky" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyTicketSticky',
  props: {
    text: {},
    link: {},
    linkText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.text), 1),
      _createElementVNode("a", {
        class: "button",
        href: _ctx.link
      }, _toDisplayString(_ctx.linkText), 9, _hoisted_3)
    ])
  ]))
}
}

})